import axios from "axios";
import { useToast } from "vue-toastification";
import { extractErrorMessage } from "@/utils/errorHandler";

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

const toast = useToast();

let activeRequests = 0;
let loadingMessage = null;
let lastToastMessage = null;

apiClient.interceptors.request.use(
  (config) => {
    activeRequests++;

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config._hadAuthToken = Boolean(token);

    return config;
  },
  (error) => {
    activeRequests--;
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    activeRequests--;

    if (activeRequests === 0 && loadingMessage) {
      loadingMessage();
    }

    return response;
  },
  (error) => {
    activeRequests--;

    const status = error?.response?.status;
    const message = extractErrorMessage(error);
    const isAuthExpired = status === 401 && error?.config?._hadAuthToken;

    // جلوگیری از toast تکراری
    if (!isAuthExpired && message !== lastToastMessage) {
      toast.error(message);
      lastToastMessage = message;

      setTimeout(() => {
        lastToastMessage = null;
      }, 2000);
    }

    if (isAuthExpired) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("ismaster");
      localStorage.removeItem("licenseInfo");
      localStorage.removeItem("companyisactive");
      localStorage.removeItem("companyInfo");
      localStorage.removeItem("storageInfo");

      setTimeout(() => {
        window.location.href = "/login?sessionExpired=1";
      }, 500);
    }

    if (!error.response) {
      toast.error("سرور در دسترس نیست.");
    }

    return Promise.reject(error);
  }
);

export default apiClient;
